import { Injectable } from '@angular/core';
import { AbstractClientService } from './abstract-client.service';
import { ClientDto, CreateClientDto, UpdateClientDto } from '@shared/dto';

@Injectable({
  providedIn: 'root'
})
export class ClientService extends AbstractClientService<ClientDto, CreateClientDto, UpdateClientDto> {}

